import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "../_keys";
import { Routes } from "../_routes";

const changeCustomersGroup = (data: ChangeCustomersGroupReqT) =>
  axios.post(Routes.CHANGE_CUSTOMERS_GROUP, data);

export const useChangeCustomersGroup = () => {
  return useMutation({
    mutationKey: [Keys.CHANGE_CUSTOMERS_GROUP],
    mutationFn: changeCustomersGroup,
  });
};
